/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AggregateByLayerAndRoleRequest } from '../models/AggregateByLayerAndRoleRequest';
import type { AggregateByLayerAndRoleResponse } from '../models/AggregateByLayerAndRoleResponse';
import type { FinancialMetadataListResponse } from '../models/FinancialMetadataListResponse';
import type { NumericKeysResponse } from '../models/NumericKeysResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FinancialDataService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List Financial Metadata
     * List available FinancialInfoMetaData entries, filtered to what the user can access.
     * @param country Filter metadata by country
     * @returns FinancialMetadataListResponse Successful Response
     * @throws ApiError
     */
    public listFinancialMetadataApiV1FinancialDataMetadataGet(
        country?: (string | null),
    ): CancelablePromise<FinancialMetadataListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/financial-data/metadata',
            query: {
                'country': country,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Numeric Keys
     * Return keys in dtype_definitions that are numeric.
     * @param metaId
     * @returns NumericKeysResponse Successful Response
     * @throws ApiError
     */
    public listNumericKeysApiV1FinancialDataMetadataMetaIdNumericKeysGet(
        metaId: string,
    ): CancelablePromise<NumericKeysResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/financial-data/metadata/{meta_id}/numeric-keys',
            path: {
                'meta_id': metaId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Aggregate By Layer And Role
     * Aggregate a selected numeric metric across companies in the current graph,
     * grouped by relative layer and stacked by company role.
     * The client supplies the set of domains with their layers and roles for this graph.
     * @param requestBody
     * @returns AggregateByLayerAndRoleResponse Successful Response
     * @throws ApiError
     */
    public aggregateByLayerAndRoleApiV1FinancialDataAggregateByLayerAndRolePost(
        requestBody: AggregateByLayerAndRoleRequest,
    ): CancelablePromise<AggregateByLayerAndRoleResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/financial-data/aggregate-by-layer-and-role',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
